function downloadBase64File(dataUrl: string, filename: string = "download"): void {
    // Extract MIME type from data URL
    const mimeMatch = dataUrl.match(/^data:(.*?);base64,/);
    if (!mimeMatch) {
        console.error("Invalid data URL");
        return;
    }

    const mimeType: string = mimeMatch[1];
    const base64Data: string = dataUrl.split(',')[1];

    // Convert Base64 to binary
    const byteCharacters: string = atob(base64Data);
    const byteNumbers: number[] = Array.from(byteCharacters, char => char.charCodeAt(0));
    const byteArray: Uint8Array = new Uint8Array(byteNumbers);

    // Map of common MIME types to file extensions
    const extMap: Record<string, string> = {
        "image/jpeg": "jpg",
        "image/png": "png",
        "image/tiff": "png",
        "image/gif": "gif",
        "image/tif": "gif",
        "image/svg+xml": "svg",
        "image/webp": "webp",
        "application/pdf": "pdf",
        "application/msword": "doc",
        "application/vnd.ms-excel": "xls",
        "application/vnd.ms-powerpoint": "ppt",
        "text/plain": "txt",
        "text/csv": "csv",
        "text/css": "css",
        "application/json": "json",
        "application/zip": "zip",
        "application/x-rar-compressed": "rar",
        "audio/mpeg": "mp3",
        "audio/wav": "wav",
        "video/mp4": "mp4",
        "video/webm": "webm",
        "application/octet-stream": "bin",
    };

    const extension: string = extMap[mimeType] || "bin";
    const finalFilename: string = `${filename}.${extension}`;

    const blob: Blob = new Blob([byteArray], { type: mimeType });
    const link: HTMLAnchorElement = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = finalFilename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
export  {downloadBase64File}